'use strict';
/**
 * confirmationModal
 * 
 */
angular.module('harriApp').directive('confirmationModal', ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            title: '@'
        },
        templateUrl: '../modules/forms/components/confirmation/confirmation.html',
        link: function (scope, element, attrs, formCtrl) {
            scope.$on('modalConfirm', function (event, title, cb) {

                $('#modal-confirm').appendTo( "body" );
                scope.isDisabled = false;
                $timeout(function () {
                    scope.title = title;
                    scope.cb = cb;
                    $('#modal-confirm').modal('show');
                });
            });
            scope.$on('closeModalConfirmation', function (event) {
                $timeout(function () {
                    $('#modal-confirm').modal('hide');
                });
            });

            scope.isDisabled = false;
            scope.deleteQuestion = function () {
                scope.isDisabled = true;
                scope.cb();
                $timeout(function(){
                    scope.$apply();
                });
            };
        }
    };
}]);